export const SWITCH_LOCATION_CONFIRM_BUTTON_TEXT = "Switch Location";
export const CANCEL_BUTTON_TEXT = "Cancel";
export const DEFAULT_CONFIRM_BUTTON_TEXT = "Yes, I am sure";
